import { render, staticRenderFns } from "./KaryawanAdd.vue?vue&type=template&id=31ce6f49&scoped=true"
import script from "./KaryawanAdd.vue?vue&type=script&lang=js"
export * from "./KaryawanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce6f49",
  null
  
)

export default component.exports